module.exports = __webpack_public_path__ + "img/backgroundFeature2.00474ef7.svg";